import { render, staticRenderFns } from "./CampaignDetailSlug.vue?vue&type=template&id=364450c6"
import script from "./CampaignDetailSlug.vue?vue&type=script&lang=js"
export * from "./CampaignDetailSlug.vue?vue&type=script&lang=js"
import style0 from "./CampaignDetailSlug.vue?vue&type=style&index=0&id=364450c6&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports